module.exports = __webpack_public_path__ + "media/images/checkmark_600-3006cc4a24a624e4289029fe97998231.png";